import { Box, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../../api/hooks/useColors";
import LabelsDropdown from "../../components/LabelsDropDown/LabelsDropdown";

export default function MoreLabelsChip({ entity, labels, width }) {
  const colors = useColors();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap="6px"
        border={`0.5px solid ${colors.button_outlined_inherit_enabled_stroke}`}
        onClick={(event) => setMenuAnchorEl(event.currentTarget)}
        sx={{
          height: "24px",
          width: width,
          borderRadius: "12px",
          paddingX: "8px",
          minWidth: width,
          cursor: "pointer",
        }}
      >
        <Typography variant="caption" color={colors.text_secondary}>
          +{labels.length}
        </Typography>
      </Box>
      {menuAnchorEl && (
        <LabelsDropdown
          selectedEntities={[entity]}
          menuAnchorEl={menuAnchorEl}
          setMenuAnchorEl={setMenuAnchorEl}
        />
      )}
    </>
  );
}
